/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_AgendaInputs */



/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Tournament_AgendaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_agenda = /** @type {((inputs?: Tournament_AgendaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_AgendaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agenda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Agenda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Agenda")
	return /** @type {LocalizedString} */ ("Agenda")
});